import { render, staticRenderFns } from "./ImageGalleryModal.vue?vue&type=template&id=32388d00&scoped=true&"
import script from "./ImageGalleryModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImageGalleryModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImageGalleryModal.vue?vue&type=style&index=0&id=32388d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32388d00",
  null
  
)

export default component.exports